import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import FormWindow from '../components/windows/FormWindow';
import FramingIntentsForm from '../components/fdl_forms/FramingIntentsForm';
import CanvasForm from '../components/fdl_forms/CanvasForm';
import ReviewForm from '../components/fdl_forms/ReviewForm';
import ListTree from '../components/tree/ListTree';
import NavBar from '../components/nav/navbar';
import FdlButton from '../components/buttons/FdlButton'
import {
  Link
} from '@mui/material';

// TODO: Restructure the camera and intents data to remove the label ('Example Camera') as the key for the nested object, and to intead
// make it a key-value pair inside the object. Turn the testCameraData object into an array of objects
const testCameraData = {
  "Example Camera": {
    "Camera ID": "Example_Camera",
    "Source Canvas ID": "A_Previous_Canvas",
    "Camera Manufacturer": "ARRI",
    "Camera Model": "ARRI Alexa 65",
    "Camera Resolution": "ARRI - 65 1.78 Crop - 5120x2280",
    "Effective Res X": 1800,
    "Effective Res Y": 1500,
    "Photosite X": 1920,
    "Photosite Y": 1080,
    "Resolution X": 2000,
    "Resolution Y": 2000,
    "Sensor Physical Dimensions X": 42,
    "Sensor Physical Dimensions Y": 68.5,
    "Anamorphic Squeeze": 2
  },
  "Example Camera 2": {
    "Camera ID": "Example_Camera_2",
    "Source Canvas ID": "A_Previous_Canvas2",
    "Camera Manufacturer": "ARRI",
    "Camera Model": "ARRI Alexa 65",
    "Camera Resolution": "ARRI - 65 1.78 Crop - 5120x2280",
    "Effective Res X": 1800,
    "Effective Res Y": 1500,
    "Photosite X": 1920,
    "Photosite Y": 1080,
    "Resolution X": 2000,
    "Resolution Y": 2000,
    "Sensor Physical Dimensions X": 42,
    "Sensor Physical Dimensions Y": 68.5,
    "Anamorphic Squeeze": 2
  }
}

const testIntentsData = {
  "Framing Intent 1": {
    "Intent ID": "my_framing_intent",
    "Aspect Ratio X": 16,
    "Aspect Ratio Y": 9,
    "Protection": 0.05
  },
  "Framing Intent 2": {
    "Intent ID": "my_framing_intent_2",
    "Aspect Ratio X": 16,
    "Aspect Ratio Y": 9,
    "Protection": 0.05
  }
}

export default function FDLView(props) {


  const { transferdate } = props

  const [cameraStore, setCameraStore] = useState({});
  const [intentsStore, setIntentsStore] = useState({});

  const [listTreeView, setListTreeView] = useState('block');
  const [currentForm, setCurrentForm] = useState('welcome');
  const [fdlData, setFdlData] = useState();

  const sessionID = Date.now();

  useEffect(()=>{
  }, [])

  const viewLayout = {
    gridTemplateColumns: 'repeat(12, 1fr)',
    bgcolor: 'rgba(0,0,0,0.5)',
    display: 'grid',
    padding: '50px',
    maxWidth: '900px',
    margin: 'auto',
    textAlign: 'left',
    overflow: 'scroll'
  };

  const formLayout = {
    gridColumnStart: '1',
    gridColumnEnd: '8'
  };

  const treeLayout = {
    gridColumnStart: '8',
    gridColumnEnd: '13',
    height: '100%'
  };

  const reviewLayout = {
    gridColumnStart: '1',
    gridColumnEnd: '13'
  };

  const containerStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    maxWidth: '1000px',
    margin: 'auto',
    height: '100%',
    overflow: 'scroll'
  }

  // Conditionally show each 'view' depending on the state of the currentForm variable (can be set in various places throughout app)
  function setView(){
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (currentForm === 'welcome'){
      return (
        <div style={{...reviewLayout, color:'white', textAlign:'left'}}>
          <h1>Framing Decision Lists</h1>
          <p style={{color:'white'}}>
            The ASC Framing Decision List is a standardised data format defined by the American Society of Cinematographers. <br></br>Version 1 was released in 2023.
          </p>
          <p>
            FDL files allow productions to document and track framing decisions from the first day of production to the last, and enables automated
            set-up of cameras and digital applications, reducing costs and improving accuracy of framings across tools.
          </p>
          <p>For more information see the <Link href="https://theasc.com/society/ascmitc/asc-framing-decision-list" style={{color:'white', textDecoration: 'underline'}}>American Society of Cinematographers' website.</Link></p>
          <FdlButton text="Begin" onClick={()=>{setCurrentForm('intents')}}></FdlButton>
        </div>
      )
    }

    if (currentForm === 'intents'){
      return (
        <FramingIntentsForm
          style={formLayout}
          intentsDataStore={intentsStore}
          setIntentsDataStore={setIntentsStore}
          setCurrentForm={setCurrentForm}
        />
      )
    }
    if (currentForm === 'camera'){
      return (
        <CanvasForm
          style={formLayout}
          intentsDataStore={intentsStore}
          cameraDataStore={cameraStore}
          setCameraDataStore={setCameraStore}
          setCurrentForm={setCurrentForm}
          fdlData={fdlData}
          setFdlData={setFdlData}
        />
      )
    }
    if (currentForm === 'review'){
      return (
        <ReviewForm
          style={reviewLayout}
          cameraData={cameraStore}
          intentData={intentsStore}
          setCurrentForm={setCurrentForm}
          fdlData={fdlData}
          setFdlData={setFdlData}
          sessionID={sessionID}
        />
      )
    }
  }

  function showList(){
    if (currentForm === 'intents' || currentForm === 'camera'){
      return (<ListTree
        style={treeLayout}
        intentData={intentsStore}
        // intentData={testIntentsData}
        setIntentData={setIntentsStore}
        cameraData={cameraStore}
        // cameraData={testCameraData}
        setCameraData={setCameraStore}
      />)
      }
  }


  return (
    <React.Fragment>
      <Box style={containerStyle}  >
        <NavBar
          currentForm={currentForm}
          setCurrentForm={setCurrentForm}
          cameraDataStore={cameraStore}
          intentsDataStore={intentsStore}
          setFdlData={setFdlData}
        />
        <Box id='yamum' style={{overflow:'scroll'}}>
          <FormWindow id='formwindow' style={viewLayout}>
            {setView()}
            {showList()}
          </FormWindow>
        </Box>
      </Box>
    </React.Fragment>
  );
};


